import { type ReactElement } from 'react';

export const MultimediaIcon = (): ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.7256 15.9004C15.3069 15.9005 15.7792 16.0362 16.1299 16.3203C16.4896 16.6015 16.667 16.9954 16.667 17.4883C16.6669 17.8204 16.5813 18.1167 16.4082 18.373L16.4072 18.374C16.2623 18.5836 16.067 18.7397 15.8262 18.8467C16.1187 18.9348 16.3512 19.086 16.5156 19.3057C16.7088 19.5639 16.7998 19.905 16.7998 20.3174C16.7997 20.7986 16.6587 21.1967 16.3721 21.5029L16.2402 21.6289C15.8721 21.9472 15.3652 22.0996 14.7334 22.0996C14.0425 22.0996 13.51 21.9397 13.1562 21.6006C12.8076 21.2662 12.6238 20.8286 12.6006 20.2969L12.5957 20.1924H13.5752L13.583 20.2832C13.615 20.6374 13.7201 20.8736 13.8809 21.0127C14.0493 21.1534 14.3216 21.2334 14.7168 21.2334C15.0922 21.2334 15.3593 21.1494 15.5342 20.998L15.5977 20.9365C15.7359 20.7849 15.8086 20.5786 15.8086 20.3086C15.8085 19.9644 15.7123 19.7232 15.5361 19.5664C15.3575 19.4076 15.0791 19.3194 14.6836 19.3193H14.042V18.4854H14.7002C15.0267 18.4853 15.2657 18.3983 15.4307 18.2373C15.5971 18.0694 15.6836 17.8467 15.6836 17.5605C15.6835 17.2916 15.5975 17.1014 15.4375 16.9727L15.4365 16.9717C15.2778 16.8403 15.0399 16.7667 14.709 16.7666C14.3959 16.7666 14.1655 16.8396 14.0059 16.9717C13.8474 17.1029 13.7358 17.3183 13.6826 17.6348L13.668 17.7178H12.6875L12.7012 17.6064C12.7646 17.0663 12.971 16.6418 13.3281 16.3457C13.6839 16.0454 14.1535 15.9004 14.7256 15.9004Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 16C21.1046 16 22 16.8954 22 18V20C22 21.1046 21.1046 22 20 22H18V16H20ZM19 21H20C20.5523 21 21 20.5523 21 20V18C21 17.4477 20.5523 17 20 17H19V21Z"
        fill="currentColor"
      />
      <path d="M21 4.00195V13.001H20V5.00098H4V19.001H9V20.001H3V4L21 4.00195Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0078 12L10 14.8613V9.13867L15.0078 12ZM11 13.1377L12.9912 12L11 10.8613V13.1377Z"
        fill="currentColor"
      />
    </svg>
  );
};
